export default "__VITE_PUBLIC_ASSET__7f48e91a__"